// extracted by mini-css-extract-plugin
export default {"container":"Tk-z","blurb":"Uk-z","links":"Vk-z"};